define(
	'app/ui/rotator/home',[
		'jquery'
	],

	function ($) {
		var selectors = {
			wrapper: '.js-home-rotator',
			rotator: '.js-rotator',
			slide: '.js-home-rotator__slide',
			link: '.js-home-rotator__link',

			prev: '.js-home-rotator__prev',
			next: '.js-home-rotator__next',

			captionSmall: '.js-home-rotator__caption-small',
			captionLarge: '.js-home-rotator__caption-large'
		};

		var dataSelectors = {
			flickity: 'flickity-instance',

			captionSmall: 'home-rotator-caption-small',
			captionLarge: 'home-rotator-caption-large'
		};

		var $wrapper;
		var $rotator;
		var $slides;
		var $links;

		var $prev;
		var $next;

		var $captionSmall;
		var $captionLarge;

		var flick;

		var isStaticClick = false;
		var clearStaticClickTimeout;
		var clearStaticClickDelay = 50; // ms

		var module = {
			init: function () {
				module._initElements();
				module._initEvents();
			},

			_initElements: function () {
				$wrapper = $(selectors.wrapper);
				$rotator = $wrapper.find(selectors.rotator);
				$slides = $rotator.find(selectors.slide);
				$links = $slides.find(selectors.link);

				$prev = $wrapper.find(selectors.prev);
				$next = $wrapper.find(selectors.next);

				$captionSmall = $wrapper.find(selectors.captionSmall);
				$captionLarge = $wrapper.find(selectors.captionLarge);

				flick = $rotator.data(dataSelectors.flickity);
			},

			_initEvents: function () {
				// "staticClick" event fires before "click" event,
				// use this to decide whether or not to cancel the
				// regular "click" event
				flick.on('staticClick', module._setStaticClick);
				$links.on('click', module._preventDefaultUnlessStatic);

				$prev.on('click', module._prev);
				$next.on('click', module._next);

				flick.on('change', module._onChange);
			},

			_setStaticClick: function () {
				isStaticClick = true;

				if (clearStaticClickTimeout) {
					window.clearTimeout(clearStaticClickTimeout);
				}
				clearStaticClickTimeout = window.setTimeout(module._clearStaticClick, clearStaticClickDelay);
			},

			_clearStaticClick: function () {
				isStaticClick = false;
				clearStaticClickTimeout = undefined;
			},

			_preventDefaultUnlessStatic: function (e) {
				if (!isStaticClick) {
					e.preventDefault();
				}
			},

			_prev: function (e) {
				flick.previous();
			},

			_next: function (e) {
				flick.next();
			},

			_onChange: function (i) {
				var $slide = $slides.eq(i);

				module._setCaption($slide);
			},

			_setCaption: function ($slide) {
				var smallCaption = $slide.data(dataSelectors.captionSmall);
				var largeCaption = $slide.data(dataSelectors.captionLarge);

				$captionSmall.text(smallCaption);
				$captionLarge.text(largeCaption);
			}
		};

		return {
			init: module.init
		};
	}
);
